(() => {
  function mount(root = document) {
    root.querySelectorAll('[data-idf-demo-form]').forEach((form) => {
      if (form.dataset.idfDemoBound === 'true') return;
      form.dataset.idfDemoBound = 'true';

      const fields = [...form.querySelectorAll('[data-idf-field]')];
      const status = form.querySelector('[data-idf-demo-status]');
      const checkButton = form.querySelector('[data-idf-demo-check]');

      function showError(field, message) {
        const error = field.closest('.idf-form__field')?.querySelector('[data-idf-error]');
        if (error) {
          error.textContent = message;
          error.hidden = !message;
        }
        if (message) field.setAttribute('aria-invalid', 'true');
        else field.removeAttribute('aria-invalid');
      }

      function errorFor(field) {
        const value = field.value.trim();
        if (field.required && !value) return 'Kolom ini wajib diisi.';
        if (!value) return '';

        if (field.dataset.idfType === 'email' && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
          return 'Masukkan alamat email yang valid.';
        }
        if (field.dataset.idfType === 'phone') {
          const digits = value.replace(/\D/g, '');
          if (!/^\+?[\d ()-]+$/.test(value) || digits.length < 8 || digits.length > 15) {
            return 'Masukkan nomor telepon dengan 8–15 angka.';
          }
        }
        if (field.dataset.idfType === 'quantity' && (!/^[1-9]\d*$/.test(value) || !Number.isSafeInteger(Number(value)))) {
          return 'Masukkan jumlah unit berupa bilangan bulat positif.';
        }
        return '';
      }

      function check() {
        let firstInvalid = null;
        let errorCount = 0;
        fields.forEach((field) => {
          const error = errorFor(field);
          showError(field, error);
          if (error) {
            errorCount += 1;
            firstInvalid ||= field;
          }
        });

        if (errorCount) {
          status.textContent = `Periksa ${errorCount} kolom yang ditandai. Data belum dikirim.`;
          firstInvalid.focus();
        } else {
          status.textContent = 'Isian lengkap untuk pratinjau. Data tidak dikirim atau disimpan; harga, stok, dan balasan belum dikonfirmasi.';
        }
      }

      form.addEventListener('submit', (event) => {
        event.preventDefault();
        check();
      });
      checkButton.addEventListener('click', check);
      form.addEventListener('input', (event) => {
        if (!fields.includes(event.target)) return;
        showError(event.target, '');
        status.textContent = 'Isian berubah. Belum dikirim; periksa lagi bila sudah selesai.';
      });
      form.addEventListener('change', (event) => {
        if (!fields.includes(event.target)) return;
        showError(event.target, '');
        status.textContent = 'Isian berubah. Belum dikirim; periksa lagi bila sudah selesai.';
      });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => mount());
  else mount();
  document.addEventListener('shopify:section:load', (event) => mount(event.target));
})();
